import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Alert, Box, Button, Card, CardContent, CircularProgress, Stack, Typography } from '@mui/material';
import { apiService } from '../../services/api';

export default function EinladungAnnehmenPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const normalizedToken = useMemo(() => String(token || '').trim(), [token]);

  useEffect(() => {
    if (!normalizedToken) {
      setStatus('error');
      setError('Die Einladung enthält keinen gültigen Token.');
      return;
    }

    const acceptInvitation = async () => {
      try {
        const result = await apiService.post('/api/mandanten/einladungen/akzeptieren', { token: normalizedToken });
        setStatus('success');
        setMessage(result?.message || 'Die Einladung wurde erfolgreich angenommen.');
        window.setTimeout(() => navigate('/dashboard', { replace: true }), 1800);
      } catch (err) {
        setStatus('error');
        setError(err?.message || 'Die Einladung konnte nicht angenommen werden.');
      }
    };

    acceptInvitation();
  }, [navigate, normalizedToken]);

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, maxWidth: 720, mx: 'auto' }}>
      <Card>
        <CardContent>
          <Stack spacing={2}>
            <Typography variant="h5">Einladung annehmen</Typography>
            <Typography variant="body2" color="text.secondary">
              Die Einladung wird gerade für Ihren Account aktiviert.
            </Typography>

            {status === 'loading' ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <CircularProgress size={24} />
                <Typography>Wird verarbeitet…</Typography>
              </Box>
            ) : null}

            {status === 'success' ? (
              <Alert severity="success">{message}</Alert>
            ) : null}

            {status === 'error' ? (
              <Alert severity="error">{error}</Alert>
            ) : null}

            <Button variant="outlined" onClick={() => navigate('/dashboard')}>
              Zum Dashboard
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
